import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const BarWrapper = styled.div`
  position: relative;
  padding: 16px 8px;
  margin-top: 32px;
  display: flex;
  flex-flow: row nowrap;

  &:before {
    content: '';
    position: absolute;
    width: 100vw;
    height: 100%;
    background-color: var(--colorBlueGray1000);
    left: -24px;
    top: 0;
    z-index: -1;
  }

  & + div {
    margin-top: 16px;
  }
`;

export const Text = styled.div`
  margin-right: 16px;
`;

export const ItemWrapper = styled.div`
  margin-left: 8px;
  margin-right: 8px;
`;

export const RemovableItem = styled.div`
  padding: 11px 16px;
  background-color: var(--colorWhite);
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  margin-bottom: 4px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const RemoveIconWrapper = styled.div`
  display: block;
  height: 24px;
  cursor: pointer;

  &:focus {
    outline-color: var(--colorBlueGray1200);
  }
`;

export const RemovableItemWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const DisplayItem = styled.div`
  padding: 15px 16px;
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  margin-bottom: 4px;
  flex: 1;
`;

export const ItemSelectBox = styled.div<{ active: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid;
  border-color: ${({ active }) =>
    active ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray400)'};
  background-color: ${({ active }) => (active ? 'var(--colorBlueGray1200)' : 'transparent')};
  margin-right: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    opacity: ${({ active }) => (active ? '1' : '0')};
  }
`;

export const SideModalWrapper = styled.div`
  padding-bottom: 136px;
  background-color: var(--colorBlueGray200);
`;

export const SearchWrapper = styled.div`
  padding: 16px 32px;
  background-color: var(--colorBlueGray200);
`;

export const MenuEntryWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 28px;
  margin-bottom: 16px;
  position: relative;
  margin-left: 8px;
  margin-right: 8px;

  svg {
    fill: var(--colorBlueGray400);
  }

  &:before {
    content: '';
    height: 1px;
    background-color: var(--colorBlueGray200);
    left: -34px;
    position: absolute;
    width: 100vw;
    bottom: 0;
  }
`;

export const EntryTitle = styled.div`
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  padding: 0 16px;
  height: 48px;
  white-space: nowrap;
  width: calc(100% - 228px);
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  h5 {
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.24;
  }
`;

export const EntryPrice = styled.div`
  width: 84px;
  margin-left: 4px;
`;

export const EntryRemove = styled.div`
  width: 48px;
  height: 48px;
  margin-left: 4px;
  background-color: var(--colorWhite);
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: var(--colorBlueGray1200);
  }
`;

export const EntryInstant = styled.div`
  width: 100%;
  margin-top: 16px;
`;

export const AnimationWrapper = styled.div<{ removing: boolean }>`
  ${({ removing }) => removing && `animation: remove 0.2s linear forwards;`}
`;

export const Price = styled.div`
  margin-left: auto;
  font-weight: 600;
  margin-right: 12px;
  font-size: 14px;
  color: var(--colorBlueGray600);
  padding-left: 16px;
`;

export const CreateNewWrapper = styled.div`
  margin: 24px;
`;

export const AddButtonWrapper = styled.div`
  button {
    width: calc(100% - 16px);
    margin: 0 8px;
  }
`;
